import { StateCreator } from 'zustand';
import { PetTypeSlice, RootStore } from 'stores/pet-profile-new/types';
import { PetType } from 'constants/pet-type';
import { useCookieStore } from 'stores/cookie';

const PET_CONTEXT_COOKIE_EXPIRY_DAYS = 900;

export const petTypeSlice: StateCreator<RootStore, [], [], PetTypeSlice> = (set) => ({
  petType: PetType.Dog,
  setPetType: (petType: PetType) => {
    set(() => ({ petType }));
    const date = new Date();
    date.setDate(date.getDate() + PET_CONTEXT_COOKIE_EXPIRY_DAYS);
    useCookieStore
      .getState()
      .updateCookie('petContext', petType === PetType.Dog ? 'dogs' : 'cats', {
        expires: date,
        path: '/',
      });
  },
});
